module.exports = __webpack_public_path__ + "img/92124892-54cc2e00-edcc-11ea-8994-f15925e53b1e.a17ae51f.jpg";